import { ClientData } from '../../../shared';

export const StepOne = () => <ClientData />;
